import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { createDecorator } from './save';

var AsyncLocalStorage =
/*#__PURE__*/
function () {
  function AsyncLocalStorage() {
    _classCallCheck(this, AsyncLocalStorage);
  }

  _createClass(AsyncLocalStorage, null, [{
    key: "getItem",
    value: function () {
      var _getItem = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(key) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", localStorage.getItem(key));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getItem(_x) {
        return _getItem.apply(this, arguments);
      }

      return getItem;
    }()
  }, {
    key: "setItem",
    value: function () {
      var _setItem = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(key, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", localStorage.setItem(key, value));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function setItem(_x2, _x3) {
        return _setItem.apply(this, arguments);
      }

      return setItem;
    }()
  }]);

  return AsyncLocalStorage;
}();

var MemoryStorage =
/*#__PURE__*/
function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);
  }

  _createClass(MemoryStorage, null, [{
    key: "getItem",
    value: function () {
      var _getItem2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(key) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", MemoryStorage.db[key]);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getItem(_x4) {
        return _getItem2.apply(this, arguments);
      }

      return getItem;
    }()
  }, {
    key: "setItem",
    value: function () {
      var _setItem2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(key, value) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", MemoryStorage.db[key] = value);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function setItem(_x5, _x6) {
        return _setItem2.apply(this, arguments);
      }

      return setItem;
    }()
  }]);

  return MemoryStorage;
}();

MemoryStorage.db = {};
var Storage = typeof navigator === 'undefined' ? MemoryStorage : AsyncLocalStorage;
export function createSaveDecorator(baseOptions) {
  return createDecorator(Storage, baseOptions);
}
export default createSaveDecorator();